import PropTypes from 'prop-types';

export const availableType = PropTypes.shape({
  id: PropTypes.number,
  meta_id: PropTypes.number,
  attributes: PropTypes.shape({
    value_cm: PropTypes.number
  })
});
